export class CdProcessHelper {

  static Relocate = "55f42bde-6f91-498d-89c1-44fdbd30fa4b";
  static PerformanceProcessName = " PkPerformanceProcess";
  static AcquaintanceProcess = "PkAcquaintanceProcess";
  static SendForRevision = "5CB1F61D-50B1-4ECF-A75C-CFB40DF76466";
  static FdApprove = "efb52208-e923-430f-9066-a2949cf5a5ba";
  static FdDisapprove = "e37b3166-16bc-43d4-a180-1a4b62126142";
  static FdAdditionalExecution = "2fe9baba-f0b6-48b7-b27c-39fa3d29472d";
}